import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";



import nvq1 from '../../assets/nvq1.jpeg';
import nvq2 from '../../assets/nvq2.jpeg';
import nvq3 from '../../assets/nvq3.jpeg'; 
import nvq4 from '../../assets/nvq4.jpeg';
import nvq7 from '../../assets/nvq7.jpeg';
import nvq5 from '../../assets/nvq5.jpeg';
import nvq6 from '../../assets/nvq6.jpeg';

import nvq8 from '../../assets/nvq8.jpeg';
import nvq9 from '../../assets/nvq9.jpeg';
import nvq10 from '../../assets/nvq10.jpeg';
import nvq11 from '../../assets/nvq11.jpeg';
import nvq12 from '../../assets/nvq12.jpeg';
import nvq13 from '../../assets/nvq13.jpeg';
import nvq14 from '../../assets/nvq14.jpeg';
import nvq15 from '../../assets/nvq15.jpeg';
import nvq16 from '../../assets/nvq16.jpeg';






const sections = [

  {
    title: '',
    images: [nvq1, nvq2, nvq3, nvq4, nvq7,],
  },

    {
   
    images: [nvq12, nvq13, nvq14, nvq15, nvq16],
  },

    {
   
    images: [nvq5, nvq6,  nvq8, nvq9, nvq10, nvq11,],
  },


]





const NvqworkshopColombo = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
        <h1 align="center">NVQ Workshop Colombo - 2026 | Phase 03 </h1>
        <p className="intro-annualmeeting">
        Be Qualified, Be Certified 🎓👀 Phase 03 in Colombo, held on 26th April 2026, 
        was successfully completed. A heartfelt thank you to everyone who participated 
        in our NVQ Level 3 and Level 5 Workshop. Your dedication, enthusiasm, 
        and commitment made this event a great success.
        </p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};


export default NvqworkshopColombo